<div *ngIf="paging && paging.show" class="paging">
  <!-- prevLink -->
    <!-- icon @@@ make ui-icon -->
  <ng-container [ngSwitch]="paging.configuration.prevLinkElement?.type" *ngIf="paging.configuration.actionIfNoLink !== 'hide'">
    <i *ngSwitchCase="'icomoon'" class="prevLink" [ngClass]="paging.configuration.prevLinkElement?.value" [class.link-disabled]="!paging.hasPrevLink" (click)="onClickPrevLink()"></i>
    <i *ngSwitchCase="'fontawesome'" class="prevLink" [ngClass]="paging.configuration.prevLinkElement?.value" [class.link-disabled]="!paging.hasPrevLink" (click)="onClickPrevLink()"></i>
    <img *ngSwitchCase="'src'" class="prevLink" [src]="paging.configuration.prevLinkElement?.value" [class.link-disabled]="!paging.hasPrevLink" (click)="onClickPrevLink()">
  </ng-container>


  <!-- values
  ===============================-->
  <!-- paging -->
  <div *ngIf="paging.configuration.pagingEnabled">
    <span class="current-page">{{paging.currentPage}}</span>
    <span class="separator-cur-total-page">{{paging.configuration.separatorCurTotalPage}}</span>
    <span class="total-page">{{paging.totalPage}}</span>
  </div>
  <!-- the range -->
  <div class="pagination-text"*ngIf="paging.configuration.rangeEnabled">
    <span class="first-of-range">{{paging.firstOfRange}}</span>
    <span class="separator-range">{{paging.configuration.separatorRange}}</span>
    <span class="last-of-range">{{paging.lastOfRange}}</span>
  </div>

  <!-- nexLink -->
  <!-- icon @@@ make ui-icon -->
  <ng-container [ngSwitch]="paging.configuration.nextLinkElement?.type" *ngIf="paging.configuration.actionIfNoLink !== 'hide'">
    <i *ngSwitchCase="'icomoon'" class="nextLink" [ngClass]="paging.configuration.nextLinkElement?.value" [class.link-disabled]="!paging.hasNextLink" (click)="onClickNextLink()"></i>
    <i *ngSwitchCase="'fontawesome'" class="nextLink" [ngClass]="paging.configuration.nextLinkElement?.value" [class.link-disabled]="!paging.hasNextLink" (click)="onClickNextLink()"></i>
    <img *ngSwitchCase="'src'" class="nextLink" [src]="paging.configuration.nextLinkElement?.value" [class.link-disabled]="!paging.hasNextLink" (click)="onClickNextLink()">
  </ng-container>
</div>


